module.exports = __webpack_public_path__ + "img/office.b5b3e4fd.svg";